const isIE = () =>
  '-ms-scroll-limit' in document.documentElement.style &&
  '-ms-ime-align' in document.documentElement.style;

const onScroll = (headerHeight = 0) => {
  const banner = document.querySelector('.right-tizer-banner');

  if (banner) {
    const marginTop = 16;
    banner.style.top = `${headerHeight + marginTop}px`;
  }
};

document.addEventListener('DOMContentLoaded', () => {
  const headerApiReady = () => {
    // eslint-disable-next-line no-unused-expressions
    window.$mos_layouts.on &&
      window.$mos_layouts.on('change:headerHeight', (headerHeight) => {
        if (Number.isFinite(headerHeight) && headerHeight !== 0) {
          onScroll(headerHeight);
          window.addEventListener('scroll', () => onScroll(headerHeight));
          window.addEventListener('orientationchange', () =>
            onScroll(headerHeight)
          );
        }
      });
  };

  if (!isIE()) {
    if (window.$mos_layouts && window.$mos_layouts.on) {
      headerApiReady();
    } else {
      document.addEventListener('change:displayHeader', headerApiReady, false);
    }
  }
});
export default undefined;
